import { Link } from "react-router";
import { RouteFactory } from "@app/routePaths";
import defaultMastheadImage from "@assets/logo-masthead.svg";
import { useHomeLink } from "@components/Header/hooks/useHomeLink";
import { cn } from "@util/helpers";

export type LogoMastheadProps = {
  rootClassName?: string;
  src?: string;
  link?: string;
  title?: string;
  imgWidth?: number;
  imgHeight?: number;
  isDisplayH1?: boolean;
};

export default function LogoMasthead({
  rootClassName = "",
  src = defaultMastheadImage,
  link = RouteFactory.home,
  title = "The Business Times",
  imgWidth = 475,
  imgHeight = 48,
  isDisplayH1 = false,
}: LogoMastheadProps): React.ReactElement {
  const homeLink = useHomeLink();
  const logoLink = [RouteFactory.home, RouteFactory.global].includes(homeLink)
    ? homeLink
    : link;
  const LinkElement = () => (
    <Link to={`${logoLink}?ref=logo`} title={title} reloadDocument>
      <img
        src={src}
        alt={title}
        width={imgWidth}
        height={imgHeight}
        className="mx-auto"
      />
    </Link>
  );

  if (isDisplayH1) {
    return (
      <div className={cn(rootClassName, "py-4 lg:py-0")}>
        <h1>
          <LinkElement />
        </h1>
      </div>
    );
  }

  return (
    <div className={cn(rootClassName, "py-4 lg:py-0")}>
      <LinkElement />
    </div>
  );
}
